import { Dropdown } from "primereact/dropdown"
import { Panel } from "primereact/panel"
import { useState, useEffect } from "react"

interface DateSelectorProps {
  dates?: string[]
  selectedDate?: string | null
  onDateChange?: (date: string | null) => void
  holidayDates?: string[] // 一斉休業日のリスト
}

const DateSelector = ({ dates = [], selectedDate, onDateChange, holidayDates }: DateSelectorProps) => {
  const [internalSelectedDate, setInternalSelectedDate] = useState<string | null>(
    selectedDate || null
  )

  // 外部からのselectedDateの変更を内部状態に反映
  useEffect(() => {
    setInternalSelectedDate(selectedDate || null)
  }, [selectedDate])

  // 日付のオプションを作成
  const dateOptions = dates.map(date => {
    const isHoliday = holidayDates?.includes(date) || false;
    return {
      label: isHoliday ? `${date} (休業日)` : date,
      value: date
    };
  });

  const handleDateChange = (value: string | null) => {
    setInternalSelectedDate(value)
    if (onDateChange) {
      onDateChange(value)
    }
  }

  return (
    <Panel toggleable header="日付毎のサマリ" className="w-full">
    <div className="p-3">
      <div className="mb-2">
        <label className="font-semibold text-sm">日付選択</label>
      </div>
      <Dropdown
        value={internalSelectedDate}
        onChange={(e) => handleDateChange(e.value)}
        options={dateOptions}
        placeholder="日付を選択してください"
        className="w-full"
        showClear
      />
      {dates.length > 0 && (
        <div className="mt-2 text-xs text-600">
          期間: {dates[0]} ～ {dates[dates.length - 1]}
        </div>
      )}
    </div>
    </Panel>
  )
}

export default DateSelector
